module.exports = __webpack_public_path__ + "img/stickers-doc-upload.d712fe87.jpg";